//Clear the radio buttons.
 


//Conditional Logic

$(document).ready(function() {
		var testimonial_ok=false;
		//Inputs that determine what fields to show
        var connectedclaim1=$('#contact_form input:checkbox[name=connectedclaim1]');
  		var connectedclaim2=$('#contact_form input:checkbox[name=connectedclaim2]');
  		var connectedclaim3=$('#contact_form input:checkbox[name=connectedclaim3]');
		
		//Wrappers for all fields
		var connecteddevice1 = $('#contact_form textarea[name="connectedclaim1"]').parent();
		var modelnumber1 = $('#contact_form textarea[name="modelnumber1"]').parent();
  		var connecteddevice2 = $('#contact_form textarea[name="connecteddevice2"]').parent();
		var modelnumber2 = $('#contact_form textarea[name="modelnumber2"]').parent();
  		var connecteddevice3 = $('#contact_form textarea[name="connecteddevice3"]').parent();
		var modelnumber3 = $('#contact_form textarea[name="modelnumber3"]').parent();
		var CONDEV1  = $('#contact_form #CONDEV1');
 		var CONDEV2  = $('#contact_form #CONDEV2');
		var CONDEV3  = $('#contact_form #CONDEV3');
		var all=connecteddevice1.add(connecteddevice2).add(connecteddevice3).add(modelnumber1).add(modelnumber2).add(modelnumber3).add(CONDEV1).add(CONDEV2).add(CONDEV3);
	
  
  		connectedclaim1.prop('checked', false);
    	connectedclaim2.prop('checked', false);
    	connectedclaim3.prop('checked', false);
  
		connectedclaim1.change(function(){
			var value=this.value;						
          
          	if ( $('input[name="connectedclaim1"]').is(':checked') ) {
               CONDEV1.removeClass('hidden');
            } 
            else {
				CONDEV1.addClass('hidden');
            }
	
		});	

  		connectedclaim2.change(function(){
			var value=this.value;						
			
			if ( $('input[name="connectedclaim2"]').is(':checked') ) {
				CONDEV2.removeClass('hidden');
			}
			else {
				CONDEV2.addClass('hidden');
			}		
		});	

  		connectedclaim3.change(function(){
			var value=this.value;						
			
			if ( $('input[name="connectedclaim3"]').is(':checked') ) {
				CONDEV3.removeClass('hidden');
			}
			else {
				CONDEV3.addClass('hidden');
			}		
		});	


});

